import { mapDTO } from '@twistezo/ts-dto-mapper'

import { DomainRichPlacementKWords } from '../../types/domainRichPlacementKWords'
import { DomainRichPlacementKWordsConfigurationDTO } from '../types/domainRichPlacementKWordsConfigurationDTO'

type From = DomainRichPlacementKWordsConfigurationDTO
type To = DomainRichPlacementKWords

export const domainRichPlacementKWordsFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({
      availability,
      customVariableName,
      customVariableTriggerEnabled,
      customVariableValue,
      enabled,
      kwordsSiteId,
      matchType,
      overrideWorkspaceDefaultsEnabled,
      path,
      pathTriggerEnabled,
    }: From): To => ({
      availability: availability ?? undefined,
      customVariableName: customVariableName ?? undefined,
      customVariableTriggerEnabled,
      customVariableValue: customVariableValue ?? undefined,
      enabled,
      kwordsSiteId: kwordsSiteId ?? undefined,
      matchType,
      overrideWorkspaceDefaults: overrideWorkspaceDefaultsEnabled ?? undefined,
      path: path ?? undefined,
      pathTriggerEnabled,
    }),
  )
